import React from 'react'
import { formatDate } from '../../utils/format'

interface SinceLastVisitBannerProps {
  /** When the user last visited before this session (ISO). */
  previousVisitAt: string | null
  /** Dates (YYYY-MM-DD or ISO) of all known changes on the profile. */
  changeDates: string[]
  onShow: () => void
}

/** Changes whose CVR date falls after the previous visit (by day). */
export function countChangesSince(previousVisitAt: string, changeDates: string[]): number {
  const since = previousVisitAt.slice(0, 10)
  return changeDates.filter((d) => d.slice(0, 10) > since).length
}

/**
 * »N ændringer siden dit sidste besøg« (DESIGN.md → Watchlist og
 * notifikationer). Only shown when there is something new.
 */
const SinceLastVisitBanner: React.FC<SinceLastVisitBannerProps> = ({
  previousVisitAt,
  changeDates,
  onShow,
}) => {
  if (!previousVisitAt) return null
  const count = countChangesSince(previousVisitAt, changeDates)
  if (count === 0) return null
  const when = formatDate(previousVisitAt)

  return (
    <div
      className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-[10px] border border-rule bg-paper px-4 py-2.5 text-sm print:hidden"
      role="status"
      data-testid="since-last-visit"
    >
      <span className="h-2 w-2 shrink-0 rounded-full bg-ink" aria-hidden />
      <span className="text-ink">
        <span className="font-semibold">
          {count === 1 ? '1 ændring' : `${count} ændringer`}
        </span>{' '}
        siden dit sidste besøg{when ? ` ${when}` : ''}
      </span>
      <button
        type="button"
        onClick={onShow}
        className="font-semibold text-ink underline decoration-ink-300 underline-offset-[3px] hover:decoration-ink"
      >
        Vis ændringer
      </button>
    </div>
  )
}

export default SinceLastVisitBanner
